/**
 * OVERRIDE Body.jsx
 * REASON: Better wrap for Teasers.
 */

import TeaserBody from '../../../../../../components/Blocks/Teaser/Body';

export default TeaserBody;
